@if(data() != null) {
<div class="bg-white border border-gray-200 rounded-xl p-3 sm:p-5 shadow-sm space-y-4 sm:space-y-5">
  <h3 class="text-base sm:text-lg font-semibold text-gray-900">Información de la Venta</h3>
  <!-- Datos generales -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <div>
      <p class="label">Documento</p>
      <p class="value">
        {{ data()!.serie_documento }} -
        {{ data()!.correlativo_documento }}
      </p>
    </div>

    <div>
      <p class="label">Estado</p>
      <span class="px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-700">
        {{ data()!.estado }}
      </span>
    </div>

    <div>
      <p class="label">Cliente</p>
      <p class="value">
        {{ data()!.cliente_nombre_completo || '—' }}
      </p>
      @if (data()!.cliente_dni) {
      <p class="text-xs text-gray-500">DNI: {{ data()!.cliente_dni }}</p>
      }
    </div>

    <div>
      <p class="label">Fecha de Venta</p>
      <p class="value">
        {{ data()!.created_at | date : 'dd/MM/yyyy HH:mm' }}
      </p>
    </div>
  </div>

  <!-- ================= DETALLE ================= -->
  <div>
    <h4 class="font-medium text-gray-900 mb-2">Detalle de Productos</h4>

    <div class="overflow-x-auto">
      <table class="w-full text-sm border border-gray-200 rounded-lg">
        <thead class="bg-gray-50 text-gray-600">
          <tr>
            <th class="px-3 py-2 text-left">Producto</th>
            <th class="px-3 py-2 text-right">Cant.</th>
            <th class="px-3 py-2 text-right">P. Unit.</th>
            <th class="px-3 py-2 text-right">Subtotal</th>
          </tr>
        </thead>
        <tbody class="divide-y">
          @for (item of data()!.detalle; track item.producto_codigo) {
          <tr>
            <td class="px-3 py-2">
              <p class="font-medium">{{ item.producto_nombre }}</p>
              <p class="text-xs text-gray-500">{{ item.producto_codigo }}</p>
            </td>
            <td class="px-3 py-2 text-right">{{ item.cantidad }}</td>
            <td class="px-3 py-2 text-right">
              {{ item.precio_unitario | currency : 'PEN' : 'S/. ' }}
            </td>
            <td class="px-3 py-2 text-right font-medium">
              {{ item.subtotal | currency : 'PEN' : 'S/. ' }}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- ================= PAGOS + TOTALES ================= -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div>
      <h4 class="font-medium text-gray-900 mb-2">Pagos</h4>
      <ul class="space-y-2">
        @for (pago of data()!.pagos; track $index) {
        <li class="flex justify-between text-sm">
          <span>{{ pago.tipoPago_nombre }}</span>
          <span class="font-medium">
            {{ pago.monto | currency : 'PEN' : 'S/. ' }}
          </span>
        </li>
        }
      </ul>
    </div>

    <div class="bg-gray-50 rounded-lg p-4 space-y-2">
      <div class="flex justify-between">
        <span>Subtotal</span>
        <span>
          {{ subtotal() | currency : 'PEN' : 'S/. ' }}
        </span>
      </div>
      <div class="flex justify-between text-red-600">
        <span>Descuento</span>
        <span>
          -
          {{ data()!.descuento | currency : 'PEN' : 'S/. ' }}
        </span>
      </div>
      <div class="flex justify-between font-bold text-lg border-t pt-2">
        <span>Total</span>
        <span>
          {{ data()!.total | currency : 'PEN' : 'S/. ' }}
        </span>
      </div>
    </div>
  </div>
</div>
}
